import {ComponentProps} from 'react'
import StyledSelectSlider from "./StyledSelectSlider";

export const docProps : ComponentProps<typeof StyledSelectSlider> = {}

export default StyledSelectSlider;
